import type { DrCheckReport } from '@nadoutong/contracts';
import { useMutation } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { opsApiRequest } from './client.ts';

const BASE = '/v1/ops/dr-check';

export async function runDrCheck(fetchImpl: typeof fetch): Promise<DrCheckReport> {
  return opsApiRequest<DrCheckReport>(BASE, {}, fetchImpl);
}

/**
 * Mutation-shaped hook so the UI treats it as a user-triggered action
 * rather than a passive fetch. The DR check performs writes against
 * platform-db (sentinel INSERT/DELETE) and consumes real DB load, so
 * auto-refetching it on mount would be wrong.
 */
export function useDrCheck(): UseMutationResult<DrCheckReport, Error, void> {
  const { fetchImpl } = useSession();
  return useMutation({
    mutationFn: () => runDrCheck(fetchImpl),
  });
}
